export default __webpack_public_path__ + "static/media/link.f914d432.svg";